module.exports = __webpack_public_path__ + "static/img/phone.3ab70ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/img/phone.png
// module id = xCOu
// module chunks = 1